import styled from 'styled-components'

export const BodyWrapper = styled.div`
  width: 100%;
  max-width: 1366px;
  box-sizing: border-box;
  padding: 0 1.25rem 2.25rem;
`

export const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`
